import { useContext, useMemo } from 'react';
import DashboardsContext from '../../contexts/DashboardsContext';

const useTemplateInstances = (template?: DashboardType): DashboardType[] => {
  const { allDashboards } = useContext(DashboardsContext);

  const templateInstances = useMemo(() => {
    if (!template) {
      return [];
    }
    if (template.isTemplate) {
      return allDashboards.filter((d) => d.templateId === template.id);
    } else {
      return [];
    }
  }, [allDashboards, template]);

  return templateInstances;
};

export default useTemplateInstances;
